import type { IAnalyticsEventFormField } from '@sravni/cosago-react-library/lib/types';
import { type FC, useCallback } from 'react';

import { useAppDispatch } from 'shared/lib';
import { logFormData } from 'shared/lib/logFormData';
import { sendEventFillFormField } from 'shared/lib/sendGAEvents';
import { SendEventWrapper } from 'shared/lib/sendGAEvents/SendEventWrapper';
import { useUpdateStateBySelector } from 'shared/lib/useUpdateStateBySelector';

import {
  PassportFormValidationSchema,
  type TPassportFormFields,
  selectPassportInfoData,
  setPassportInfo,
} from 'src/client/entities/creditForm';

import { submitPassportForm } from 'features/UpdatePassportInfo/lib/submitPassportForm';

import { FormFieldsControls } from '../../PassportInfo.config';
import { PassportInfoTexts } from '../../PassportInfo.texts';
import { PassportInfoViewHoc } from '../FormBody/FormBody';

export const Form: FC<
  IFormPopup & {
    shouldRestoreAdditionalData?: boolean;
  }
> = ({
  isLoading,
  isDialog = false,
  onClose,
  setHeader,
  isFormForceOpened,
  onFormSubmit,
  shouldRestoreAdditionalData,
  stepIndex,
  formId,
  submitButtonText = 'Далее',
  isAnyFormStepOpenedInPopup,
}) => {
  const dispatch = useAppDispatch();
  const [formData] = useUpdateStateBySelector(selectPassportInfoData);

  const handleData = async (actualData: TPassportFormFields, type: string) => {
    if (type === 'fullFilled') {
      logFormData('PassportInfo FormStep SubmitData', actualData);
      await dispatch(setPassportInfo({ data: actualData, isFullFilled: true }));
      dispatch(submitPassportForm(actualData));
      onFormSubmit?.(actualData, isDialog);
    }
    if (isDialog) {
      onClose?.(true);
    }
  };

  const sendAnalyticsEvent = useCallback(
    ({ fieldName }: IAnalyticsEventFormField) => {
      sendEventFillFormField(stepIndex + 1, PassportInfoTexts[fieldName as keyof TPassportFormFields], true);
    },
    [stepIndex],
  );

  return (
    <SendEventWrapper sendEvent={sendAnalyticsEvent}>
      <PassportInfoViewHoc
        isDialog={isDialog}
        onDataChanged={handleData}
        defaultData={formData}
        validationSchema={PassportFormValidationSchema()}
        isLoading={isLoading}
        additionalProps={{
          setHeader,
          isFormForceOpened,
          shouldRestoreAdditionalData: !!shouldRestoreAdditionalData,
          formId,
          isAnyFormStepOpenedInPopup,
        }}
        formLabels={PassportInfoTexts}
        formFieldsControls={FormFieldsControls}
        submitButtonText={submitButtonText}
      />
    </SendEventWrapper>
  );
};
